<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper mt-n12" style="height: 100vh;">
        <v-card class="modal-container text-center depositContainer mb-5 mt-5" :color="$vuetify.theme.dark ? '#232D3F' : ''" elevation="0"  >
          <!-- Modal content here -->
          <div class="d-flex">
            <v-btn v-if="inOperatingMode" elevation="0" fab  small class="modal-default-button title"
               @click="onBack">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn elevation="0" fab color="error" small class="modal-default-button title"
             @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </div>

          <v-card-text class="display-1 "> {{titleTxt}}</v-card-text>
          <template v-if="!inOperatingMode">
      
            <v-card-actions class="d-flex justify-center gap-2 pa-8" >
              <v-btn x-large color="success" @click="onSelectDeposit" class="mr-8" >
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Deposit</v-btn>
              <v-btn x-large color="warning" @click="onSelectWithdraw">    <v-icon class="mr-2">mdi-cash-minus</v-icon>Withdraw</v-btn>

            </v-card-actions>

          </template>
          <template v-else>

          <v-progress-linear
            v-if="isLoadingUsers"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field v-model="username" @focus="handleUserNameFocus" label="Username" required></v-text-field>
            </v-form>
            <div v-if="userListWithFullNameAndIdAndInfo.length > 0">
              <v-select
                v-model="selectedUser"
                :items="userListWithFullNameAndIdAndInfo"
                label="Select User"
                item-text="fullNameAndIdAndInfo"
                item-value="id"
                :item-disabled="item => item.status !== 'Active'"
              ></v-select>
            </div>
            <v-alert
              v-if="selectedUserDepositLimit && inDepositMode"
              dense
              type="warning"
            >
              {{ selectedUserDepositLimit }}
            </v-alert>
            <v-btn v-if="selectedUser === null" color="primary" @click="searchUsers" :disabled="isLoadingUsers">Search Users</v-btn>
            <v-btn
            v-if="selectedUser"
                @click="selectedUser = null"
                color="primary"
                label="Clear Selected User"
              >Clear Selected User</v-btn>
          </v-card-text>
          <v-card v-if="selectedUser" class="mx-5 mt-5" elevation="0">
            <div>
              <div v-if="!highDomKeyboard" class="row" slot="body" style="width:500px;">
                <v-switch v-model="keypad" label="Keypad"></v-switch>
                <div class="col-12">
                  <div v-if="keypad" style="width:60%;margin:0 auto;">
                    <SimpleKeyboardAMT @onChange="onChange" :input="stake" />
                  </div>
                  <div v-if="!keypad" class="row">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(1)">$1</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(2)">$2</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(5)">$5</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(10)">$10</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(20)">$20</v-btn>
                  </div>
                </div>
                <div v-if="!keypad" class="col-12">
                  <div class="row">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(50)">$50</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(100)">$100</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(200)">$200</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(500)">$500</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 white--text headline font-weight-bold" width="60"
                      color="red" @click="amount = ''">Clear</v-btn>
                  </div>
                </div>
              </div>
              <div v-if="highDomKeyboard" class="row" slot="body" style="width:500px;">
                <v-switch v-model="keypad" label="Keypad"></v-switch>
                <div class="col-12">
                  <div v-if="keypad" style="width:60%;margin:0 auto;" class="mt-n10">
                    <SimpleKeyboardAMT @onChange="onChange" :input="input" />
                  </div>
                  <div v-if="!keypad" class="row ml-10">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(100)">$100</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(200)">$200</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(500)">$500</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(1000)">$1000</v-btn>
                  </div>
                </div>
                <div v-if="!keypad" class="col-12">
                  <div class="row ml-10">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(2000)">$2000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(5000)">$5000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addAmount(10000)">$10000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 white--text headline font-weight-bold" width="60"
                      color="red" @click="amount = ''">Clear</v-btn>
                  </div>
                </div>
              </div>
              <v-text-field type="string" autofocus pattern="[0-9]*" v-model="amountParsed" 
                :label="hintAmount" style="width:150px;" outlined @focus="handleAmountFocus"
                class="mt-5 display-1"></v-text-field>
            </div>
          </v-card>
          <div v-if="error" class="red--text">{{ error }}</div>
          <div v-if="successMessage" class="success--text">{{ successMessage }}</div>
          <v-card-actions>
            <v-btn v-if="inDepositMode" color="success" @click="showConfirmationModal = true" :disabled="!selectedUser || !valid || !amountOverMin">Deposit</v-btn>
            <v-btn v-else-if="inWithdrawMode" color="warning" @click="showConfirmationModal = true" :disabled="!selectedUser || !valid || !amount ">Withdraw</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
          </template>
        </v-card>
        <FundChangeConfirmModal
          :isLoading="isLoading"
          :amount="amount"
          :show-confirmation-modal="showConfirmationModal"
          @onConfirm="onConfirmHandler"
          @onCancel="onCancelHandler"
          :operationType="operationType"
        ></FundChangeConfirmModal>
      </div>
      <div v-if="showHideKeyboard && !selectedUser" style="width:100vw;position:absolute;left:0;bottom:0">
        <SimpleKeyboard 
          @onChange="onChange"
          @onKeyPress="onKeyPress"
          :input="input"
        />
        </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';
import SimpleKeyboard from "../components/SimpleKeyboard";
import { HIGHKEYBOARD, FUND_OP_TYPE } from '../common/constants'
import SimpleKeyboardAMT from "../components/SimpleKeyboardAMT";
import { mapGetters, mapActions } from "vuex";
import FundChangeConfirmModal from './FundChangeConfirmModal.vue'
import {
  generateCustomerFundChangeReceipt
} from "../common/tickets";

export default {
  data() {
    return {
      operationType: FUND_OP_TYPE.NONE,
      username: '',
      amount: '',
      valid: false,
      userList: [],
      selectedUser: null,
      reference: '',
      keypad: false,
      error: '',
      selectedInput: null,
      showHideKeyboardAMT: false,
      showHideKeyboard: false,
      successMessage: '',
      showConfirmationModal: false,
      isLoading: false,
      isLoadingUsers: false
    }
  },
  components: {
    SimpleKeyboard,
    SimpleKeyboardAMT,
    FundChangeConfirmModal
  },
  computed: {
    ...mapGetters(['getVenueName', 'getTerminalLocation', 'getLastAuthUser']),
    inOperatingMode() {
      return this.operationType !== FUND_OP_TYPE.NONE
    },
    inDepositMode() {
      return this.operationType === FUND_OP_TYPE.DEPOSIT
    },
    inWithdrawMode() {
      return this.operationType === FUND_OP_TYPE.WITHDRAW
    },
    titleTxt() {
      switch (this.operationType) {
        case FUND_OP_TYPE.DEPOSIT:
          return 'Deposit Funds';
        case FUND_OP_TYPE.WITHDRAW:
          return 'Withdraw Funds';
        default:
          return 'Client Funds Management';
      }
    },
    hintAmount () {
      if (this.amount <= 10 && this.inDepositMode) return 'Min Amount $10'
      return 'Amount'
    },
    amountOverMin () {
      if (this.amount >= 10) return true
      return false
    },
    amountParsed () {
      const parsedNumber = parseFloat(this.amount)
      if (!isNaN(parsedNumber)) {
        // Use toFixed(2) to format the number with 2 decimal places
        return parsedNumber.toFixed(2);
      } else {
        // Handle invalid input (e.g., non-numeric input)
        return '0';
      }
    },
    highDomKeyboard() {
      if (HIGHKEYBOARD[this.getVenueName]) return true
      return false
    },
    input: {
      get () { 
        if (this.selectedInput === 'username') {
          return this.selectedInput === 'username' ? this.username : this.username
        }
        if (this.selectedInput === 'amount') {
          return this.selectedInput === 'amount' ? this.amount : this.amount
        }
        return null
      },
      set () {
      }
    },
    selectedUserDepositLimit() {
    if (this.selectedUser) {
      // Check if a user is selected
      const selectedUserData = this.userList.find(user => user.id === this.selectedUser);
      if (selectedUserData.availableDeposit > 0) {
        return `Deposit Limit $${selectedUserData.availableDeposit}` || ''
      }
    }
    return 0; // Default value if no user is selected
  },
  userListWithFullNameAndIdAndInfo() {
  return this.userList?.map(user => {
        let additionalInfo = '';
        if (user.status !== 'Active') {
          additionalInfo = 'Inactive';
        } else {
          additionalInfo = `Address: ${user.address}, DOB: ${user.dob}`;
        }

        return {
          ...user,
          fullNameAndIdAndInfo: `${user.firstName} ${user.surname} (ID: ${user.id}), ${additionalInfo}`,
        };
      });
    }
  },
  methods: {
    ...mapActions([ "getTerminalToken"]),
    addAmount(amt) {
      this.amount = (parseFloat(this.amount || 0) + parseFloat(amt)).toString()
    },
    onSelectDeposit() {
      this.operationType = FUND_OP_TYPE.DEPOSIT
    },
    onSelectWithdraw() {
      this.operationType = FUND_OP_TYPE.WITHDRAW
    },
    onBack() {
      this.operationType = FUND_OP_TYPE.NONE
    },
    async searchUsers() {
      this.error = ''
      this.isLoadingUsers = true
      const token = await this.getTerminalToken()
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_LEDGER_ENDPOINT}public/ClientQuery`, {
            terminal_token: token,
            query: this.username,
          })
        if (response.status === 200) {
          this.userList = response.data.users
          if (this.userList.length === 0) {
            this.error = 'No matching users found.'
          }
        } else {
          this.error = 'Error fetching user data. Please try again.'
        }
      } catch (error) {
        console.error('Error:', error)
        // Handle errors here, e.g., show an error message to the user
        this.error = 'An error occurred. Please try again later.'
      } finally {
        // Reset isLoadingUsers to false once the query is complete
        this.isLoadingUsers = false
      }
    },
    async onConfirmHandler() {
      if (!this.selectedUser || !this.inOperatingMode ) {
        // Handle the case where no user is selected
        return;
      }
      const urlSuffix = this.inDepositMode ? 'ClientDeposit' : 'ClientWithdrawal';
      const token = await this.getTerminalToken();
      const amountToCents = parseInt(this.amount * 100) * (this.inDepositMode ? 1 : -1);

      // Set isLoading to true when the request is being sent
      this.isLoading = true;
      const transaction = {
          terminal_token: token,
          amount: this.amount,
          reason: `Customer Account ${this.operationType}`,
          type: this.operationType,
        };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_LEDGER_ENDPOINT}public/${urlSuffix}`, {
            terminal_token: token,
            user_id: this.selectedUser,
            amount: amountToCents,
          }
        );
        if (response.data.status === 'OK') {
          this.successMessage = `$${this.amount} successfully  ${this.inDepositMode ? "deposited":"withdrawn"}, this dialog will now close`;

          // Automatically close the modal after 5 seconds
            const transactionReceipt = { ...transaction, date: Date.now() };
            if (window.rt?.printImage) {
              const customerCopy = generateCustomerFundChangeReceipt (
                transactionReceipt,
                this.getTerminalLocation,
                this.getLastAuthUser,
                response.data.reference,
                this.operationType
              );
              window.rt.printImage(customerCopy)
            } else if (window.bmElectron && !window.rt?.printImage) {
              window.bmElectron.send("print-request", `printing customer ${this.operationType?.toLowerCase()}`);
            } else {
              console.log('printLocal')
              window.print();
            }
          this.closeModalAfterTimeout(5000);
        } if (response.data.status === 'OVER_DEP_LIM') {
          this.error = `$${this.amount} Amount over limit, please again try at lower limit`;

          // Automatically close the modal after 5 seconds
          this.closeModalAfterTimeout(5000);
        } if (response.data.status === 'ERROR') {
          this.error = `An error occurred. Please try again.`;

          // Automatically close the modal after 5 seconds
          this.closeModalAfterTimeout(5000);
        } 
        if (response.data.status === 'USER_INACTIVE' || response.data.status === 'USER_UNVERIFIED') {
          this.error = `${response.data.status} error when ${this.operationType?.toLowerCase()} funds. Please try again.`;

          // Automatically close the modal after 5 seconds
          this.closeModalAfterTimeout(5000);
        } 
      } catch (error) {
        console.error('Error:', error);
        // Handle errors here, e.g., show an error message to the user
        this.error = 'An error occurred. Please try again later.';
      }

      // Reset isLoading to false once the request is complete
      this.isLoading = false;

      // Close the confirmation modal after the deposit
      this.showConfirmationModal = false;
    },

    onCancelHandler() {
      // Cancel the deposit and close the confirmation modal
      this.showConfirmationModal = false;
    },
    closeModal() {
      // Close the modal
      this.$emit('close');
    },
    handleUserNameFocus() {
      this.selectedInput = 'username';
      this.showHideKeyboard = true;
      this.showHideKeyboardAMT = false;
    },
    handleAmountFocus() {
      this.selectedInput = 'amount';
      this.showHideKeyboard = false;
      this.showHideKeyboardAMT = true;
    },
    onKeyPress() {
    },
    onChange(input) {
      // eslint-disable-next-line no-debugger
      debugger
      if (this.selectedInput === 'username') {
        this.username = input;
      }
      if (this.selectedInput === 'amount') {
        this.amount = input;
      }
      if (this.keypad) {
        this.amount = input;
      }
    },
    closeModalAfterTimeout(timeout) {
      // Use $nextTick to ensure the modal is fully updated before setting the timeout
      this.$nextTick(() => {
        setTimeout(() => {
          this.$emit('close');
        }, timeout);
      });
    },
  },
}
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: none !important;
}
.depositContainer {
  width: 580px;
  margin: 0px auto;
  padding: 20px 30px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

</style>
